import { DocumentServicesListResponse } from "@/models/api/documents/DocumentServicesList";

export default [
  {
    id: "1c113f32-730f-43be-b30d-01e669b441d3",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 628-3753361587 HOVHANNISYAN ERYK ",
    quantity: 1,
    netPrice: 643.94,
    netPriceInCurrency: 643.94,
    netValue: 643.94,
    netValueInCurrency: 643.94,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 643.94,
    grossInCurrency: 643.94,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "e99ce824-2a18-43f7-aac8-06c02d52a8a4",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 176-3753362606 PASEK LUKASZ ",
    quantity: 1,
    netPrice: 10253.86,
    netPriceInCurrency: 10253.86,
    netValue: 10253.86,
    netValueInCurrency: 10253.86,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 10253.86,
    grossInCurrency: 10253.86,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "aca434d0-14fe-4ab9-8f11-081648155b75",
    name: "Bilet lotniczy międzynarodowy kontynentalny 074-3859040450 VERRASCINA LUCA ",
    quantity: 1,
    netPrice: 823.65,
    netPriceInCurrency: 823.65,
    netValue: 823.65,
    netValueInCurrency: 823.65,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 823.65,
    grossInCurrency: 823.65,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "9b851a3f-490c-4eb9-9ca1-165d5146dca2",
    name: "Bilet lotniczy międzynarodowy kontynentalny 220-3753362602 GUARDADO GUTIERREZ FRANCISCO JOSE ",
    quantity: 1,
    netPrice: 1911.22,
    netPriceInCurrency: 1911.22,
    netValue: 1911.22,
    netValueInCurrency: 1911.22,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1911.22,
    grossInCurrency: 1911.22,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "ab4c0cd4-8446-4e55-8d58-171f0eaeff13",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 628-3753361588 HOVHANNISYAN KATARZYNA ",
    quantity: 1,
    netPrice: 643.94,
    netPriceInCurrency: 643.94,
    netValue: 643.94,
    netValueInCurrency: 643.94,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 643.94,
    grossInCurrency: 643.94,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "808ff2a3-1049-4750-b162-1ed40c74b382",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 628-3859040448 KHACHATRYAN ARLENA ",
    quantity: 1,
    netPrice: 1439.16,
    netPriceInCurrency: 1439.16,
    netValue: 1439.16,
    netValueInCurrency: 1439.16,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1439.16,
    grossInCurrency: 1439.16,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "b5b165d0-3d77-4ee8-9f2c-22ed522b1a80",
    name: "Bilet lotniczy międzynarodowy kontynentalny 220-3859040451 VERRASCINA LUCA ",
    quantity: 1,
    netPrice: 1508.62,
    netPriceInCurrency: 1508.62,
    netValue: 1508.62,
    netValueInCurrency: 1508.62,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1508.62,
    grossInCurrency: 1508.62,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "0eee7a07-eaef-467d-a251-2ad3cb944411",
    name: "Bilet lotniczy zagraniczny  117-3753362618 JABLONSKI KAMIL ",
    quantity: 1,
    netPrice: 325.68,
    netPriceInCurrency: 325.68,
    netValue: 325.68,
    netValueInCurrency: 325.68,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 325.68,
    grossInCurrency: 325.68,
    serviceTypeId: null,
    vat: "np",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "de405e1d-8eef-4bfe-8e59-2b6afe3050e5",
    name: "Bilet lotniczy międzynarodowy kontynentalny 074-3867936218 LUKASZ REBACZ ",
    quantity: 1,
    netPrice: 1513.03,
    netPriceInCurrency: 1513.03,
    netValue: 1513.03,
    netValueInCurrency: 1513.03,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1513.03,
    grossInCurrency: 1513.03,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "11ed2c70-29d6-455a-b253-2c5dbe696dd2",
    name: "Bilet lotniczy międzynarodowy kontynentalny 724-3753362600 PUCHALSKA PATRYCJA IWONA ",
    quantity: 1,
    netPrice: 2831.25,
    netPriceInCurrency: 2831.25,
    netValue: 2831.25,
    netValueInCurrency: 2831.25,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 2831.25,
    grossInCurrency: 2831.25,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "8baa9e5f-5a86-4fdc-8bf7-3786cc547d5f",
    name: "Usługa EMD do biletu transkontynentalnego 628-1868608445 HOVHANNISYAN KAREN ",
    quantity: 1,
    netPrice: 226,
    netPriceInCurrency: 226,
    netValue: 226,
    netValueInCurrency: 226,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 226,
    grossInCurrency: 226,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "1384fa69-b057-4c03-815a-3dcb13f4340b",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 176-3753362615 ZAWLOCKA AGNIESZKA ",
    quantity: 1,
    netPrice: 3800.78,
    netPriceInCurrency: 3800.78,
    netValue: 3800.78,
    netValueInCurrency: 3800.78,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 3800.78,
    grossInCurrency: 3800.78,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "70c85235-4a19-417f-bbe3-421c31b1dd0b",
    name: "Bilet lotniczy międzynarodowy kontynentalny 628-3753362620 WUGERNICZEK WJACZESLAW ",
    quantity: 1,
    netPrice: 439.7,
    netPriceInCurrency: 439.7,
    netValue: 439.7,
    netValueInCurrency: 439.7,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 439.7,
    grossInCurrency: 439.7,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "2a69d614-6977-4e90-9bf1-5b4e71b1ad5c",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 628-3859040449 SIMONYAN SUREN ",
    quantity: 1,
    netPrice: 1439.16,
    netPriceInCurrency: 1439.16,
    netValue: 1439.16,
    netValueInCurrency: 1439.16,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1439.16,
    grossInCurrency: 1439.16,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "4f78c6a7-b552-4b39-bb77-60e3b4e40732",
    name: "Usługa EMD do biletu transkontynentalnego 628-1862238339 HOVHANNISYAN KATARZYNA ",
    quantity: 1,
    netPrice: 226,
    netPriceInCurrency: 226,
    netValue: 226,
    netValueInCurrency: 226,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 226,
    grossInCurrency: 226,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "f5e8c4d1-81e3-4d6c-a074-61be42af55f9",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 176-3859105570 ZELEK MAGDALENA ",
    quantity: 1,
    netPrice: 3075.78,
    netPriceInCurrency: 3075.78,
    netValue: 3075.78,
    netValueInCurrency: 3075.78,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 3075.78,
    grossInCurrency: 3075.78,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "f086159a-be6b-4627-a5ed-69db196773c4",
    name: "Bilet lotniczy zagraniczny  117-3753362617 MLECZEK JAKUB ",
    quantity: 1,
    netPrice: 1188.41,
    netPriceInCurrency: 1188.41,
    netValue: 1188.41,
    netValueInCurrency: 1188.41,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1188.41,
    grossInCurrency: 1188.41,
    serviceTypeId: null,
    vat: "np",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "06fdaae7-478f-413c-8678-84eb4af75998",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 176-3753362614 NOWAK KAMILA ",
    quantity: 1,
    netPrice: 3800.78,
    netPriceInCurrency: 3800.78,
    netValue: 3800.78,
    netValueInCurrency: 3800.78,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 3800.78,
    grossInCurrency: 3800.78,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "3101623d-9d87-4148-8dff-9777f2ec041e",
    name: "Bilet lotniczy międzynarodowy kontynentalny 220-3753362598 ROGER JOSE MARIA ",
    quantity: 1,
    netPrice: 1308.3,
    netPriceInCurrency: 1308.3,
    netValue: 1308.3,
    netValueInCurrency: 1308.3,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1308.3,
    grossInCurrency: 1308.3,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "16f35c1b-8e56-48e3-9db0-c5ef2b03afc8",
    name: "Bilet lotniczy międzynarodowy kontynentalny 074-3859040452 VAN DER AAR CORNELIS ",
    quantity: 1,
    netPrice: 1431.44,
    netPriceInCurrency: 1431.44,
    netValue: 1431.44,
    netValueInCurrency: 1431.44,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 1431.44,
    grossInCurrency: 1431.44,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "e094706d-a02b-45d3-b51b-ccd72b213543",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 176-3753362605 STANUCH RAFAL ",
    quantity: 1,
    netPrice: 10253.86,
    netPriceInCurrency: 10253.86,
    netValue: 10253.86,
    netValueInCurrency: 10253.86,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 10253.86,
    grossInCurrency: 10253.86,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "96e83b67-6a74-4259-bc9c-dced998125db",
    name: "Bilet lotniczy międzynarodowy transkontynentalny 628-3753361589 HOVHANNISYAN KAREN ",
    quantity: 1,
    netPrice: 643.94,
    netPriceInCurrency: 643.94,
    netValue: 643.94,
    netValueInCurrency: 643.94,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 643.94,
    grossInCurrency: 643.94,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "c09920f4-38d4-43a2-9674-dda8ff035e75",
    name: "Bilet lotniczy międzynarodowy kontynentalny 220-3753362599 ROGER JOSE MARIA ",
    quantity: 1,
    netPrice: 3022.28,
    netPriceInCurrency: 3022.28,
    netValue: 3022.28,
    netValueInCurrency: 3022.28,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 3022.28,
    grossInCurrency: 3022.28,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
  {
    id: "4db4111e-f937-466c-bf66-f468418c7cf3",
    name: "Usługa EMD do biletu transkontynentalnego 628-1862238338 HOVHANNISYAN ERYK ",
    quantity: 1,
    netPrice: 226,
    netPriceInCurrency: 226,
    netValue: 226,
    netValueInCurrency: 226,
    vatAmount: 0,
    vatAmountInCurrency: 0,
    gross: 226,
    grossInCurrency: 226,
    serviceTypeId: null,
    vat: "0",
    netto: 0,
    unit: null,
    modifier: 0,
  },
] as DocumentServicesListResponse;
